module.exports = __webpack_public_path__ + "static/modal-34ad57d396b50955d93cdab871e6024a.png";